import { rgba as polishedRgba, darken as makeDarker, lighten as makeLighter } from 'polished';
import { breakpoints } from './device';

export const darken = (amount: number, color: string) => {
  let finalColor = '';
  try {
    finalColor = makeDarker(amount, color);
  } catch {
    return finalColor;
  }

  return finalColor;
};

export const lighten = (amount: number, color: string) => {
  let finalColor = '';
  try {
    finalColor = makeLighter(amount, color);
  } catch {
    return finalColor;
  }

  return finalColor;
};

export const rgba = (color: number | string, transparency?: number, third?: number, fourth?: number) => {
  let finalColor = '';
  try {
    finalColor = polishedRgba(color, transparency, third, fourth);
  } catch {
    return finalColor;
  }

  return finalColor;
};

export const getCurrentViewPortKey = (): keyof typeof breakpoints => {
  const width = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

  if (width < breakpoints.xs) {
    return 'xs';
  } else if (width >= breakpoints.xs && width < breakpoints.sm) {
    return 'sm';
  } else if (width >= breakpoints.sm && width < breakpoints.md) {
    return 'md';
  } else if (width >= breakpoints.md && width < breakpoints.lg) {
    return 'lg';
  } else if (width >= breakpoints.lg) {
    return 'xl';
  }

  return 'xs';
};
